<table
    class="table">
    <thead>
        @for (col of input.columns; track $index) {
            <th>{{ col.headerName }}</th>
        }
    </thead>
    <tbody>
        @for (row of input.rows; track $index) {
            <tr>
                @for (col of input.columns; track $index) {
                    <ws-ace-simple-table-cell
                        [row]="row"
                        [col]="col"></ws-ace-simple-table-cell>
                }
            </tr>
        }
    </tbody>
    @if (input.footerRows?.length) {
        <tfoot>
            @for (row of input.footerRows; track $index) {
                <tr>
                    @for (col of input.columns; track $index) {
                        <ws-ace-simple-table-cell
                            [row]="row"
                            [col]="col"></ws-ace-simple-table-cell>
                    }
                </tr>
            }
        </tfoot>
    }
</table>
